export const getKeyByValue = <K, V>(map: Map<K, V>, valueToFind: V): K | undefined => {
  for (const [key, value] of map.entries()) {
    if (value === valueToFind) return key;
  }
  return undefined;
};
